import React from 'react';
var useEffect = React.useEffect,
  useCallback = React.useCallback,
  useState = React.useState,
  useRef = React.useRef;
import { requestTimeout, clearRequestTimeout } from '@essentials/request-timeout';
export var useThrottleCallback = function useThrottleCallback(callback) {
  var fps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var nextTimeout = useRef(null),
    tailTimeout = useRef(null),
    calledLeading = useRef(false),
    wait = 1000 / fps; // cleans up pending timeouts when the function changes

  function _ref() {
    if (nextTimeout.current !== null) {
      clearRequestTimeout(nextTimeout.current);
      nextTimeout.current = null;
    }
    if (tailTimeout.current !== null) {
      clearRequestTimeout(tailTimeout.current);
      tailTimeout.current = null;
    }
    calledLeading.current = false;
  }
  useEffect(function () {
    return _ref;
  }, [callback, fps]);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    function _ref2() {
      nextTimeout.current = null;
      tailTimeout.current === null && (calledLeading.current = false);
      callback.apply(self, args);
    }
    function _ref3() {
      tailTimeout.current = null;
      calledLeading.current = false;
      nextTimeout.current === null && callback.apply(self, args);
    }
    if (nextTimeout.current === null) {
      var next = _ref2;
      if (leading && !calledLeading.current) {
        // leading
        next();
        calledLeading.current = true;
      } else {
        // head
        nextTimeout.current = requestTimeout(next, wait);
      }
    } else {
      // tail
      tailTimeout.current !== null && clearRequestTimeout(tailTimeout.current);
      tailTimeout.current = requestTimeout(_ref3, wait);
    }
  }, [callback, fps]);
};
export var useThrottle = function useThrottle(initialState, fps, leading) {
  var _ref_0 = useState(initialState);
  var setState = _ref_0[1];
  var state = _ref_0[0];
  return [state, useThrottleCallback(setState, fps, leading)];
};
export default useThrottle;